import * as api from './project-api'
import {
    deepCopy,
    timeFilter
} from '@/untils/untils.js'
import SeriesLine from '@/components/echarts/series-normal-label'
export default {
    components: {
        SeriesLine
    },
    data() {
        /* 表单验证 */
        var checkLastPrice = (rule, value, callback) => { //最终采购价验证
            let reg = /^\d+(.\d+)?$/
            let res = reg.test(value)
            console.log(res);

            if (!res) {
                return callback(new Error('只能输入小数点和数字'));
            } else {
                callback()
            }
        }
        return {

            // header
            pageTitle: '项目信息',
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
            // table
            tableData: [{}],
            projectList: [],
            /* 招标信息列表 */
            dialogTableData: [],
            pageSize: 10,
            currPage: 1,
            total: 0,
            /* 是否为修改 */
            editFlag: false,
            bidEditFlag: false,
            curBidsIndex: '',
            /* 当前选择修改的项目的所有供应商信息 */
            curSupplierInfo: [],
            /* 已经删除的项目集合 */
            delProjectLsit: [],

            // dialog
            dialogVisible: false, //项目信息
            bidsDialogVisible: false, //投标信息
            historyDialogVisible: false, //历史报价
            confrimDialogVisible: false, //最终报价确认
            projectPlanDialogVisible: false, //项目计划任务
            downloadFileVisible: false, //下载文件弹窗
            /* 查看项目下载文件 */
            fileDialogVisible: false,
            dialogInfo: {
                tpId: '',       //项目id
                tpName: '',     //项目名字
                tpNo: '',       //项目编号
                tpDescribe: '', //项目描述
                tpManager: '',  //项目经理
                tpServiceDirector: '', //项目服务总监
                tpSalesperson: '', //项目销售
                tpDirector: '', //项目总监
                tpEngineer: '', //项目工程师
                tpPurchaseDirector: '', //项目采购总监
                tpState: '1',   //项目状态
                isGreater: '0', //是否超过十万标的
                tpCustomMsg: '', //自定义邮件消息
                fileAddBeans: [{ //附件
                    tbFileId: '',
                    tbUrl: '',
                }]

            },
            a01BiddingInfoList: [{
                tbiState: '1', //投标状态
                tbiStart: '', //投标开始时间
                tbiEnd: '', //投标结束时间
                tbiOpen: '', //开标时间
                biddingSupplierList: [], //投标供应商
            }],
            /* 供应商列表 */
            SupplierList: [],
            /* 项目投标信息 */
            ProjectDocumentData: [],
            /* 项目计划任务信息 */
            planTableData: [],
            /* 历史报价信息 */
            historyPriceData: [],
            historyType: false, //历史报价页面类型 报个和线图
            historyLineData: {},
            /* 当前项目信息 */
            curProjectInfo: {},
            /* 是否废标 */
            isOver: true,
            /* 是否到达开标时间 */
            isOpen: false,
            /* 是否竞标结束 */
            isComplete: false,
            /* 新增项目验证规则 */
            NewProjectRules: {
                tpName: [{
                    required: true,
                    message: '请输入项目名称',
                    trigger: ['blur', 'change']
                },],
                tpNo: [{
                    required: true,
                    message: '请输入项目编号',
                    trigger: ['blur', 'change']
                },],
            },
            /* 确认采购价验证规则 */
            confirmTableRules: {
                price: [{
                    validator: checkLastPrice,
                    required: true,
                    trigger: ['blur', 'change']
                }
                ],
                remark: [{
                    required: true,
                    message: '请输入备注',
                    trigger: ['blur', 'change']
                }]

            },
            /* 项目最终采购确认信息 */
            projectConfirmInfo: {
                price: '',
                remark: ''
            },
            /* 当前选择查看的供应商信息 */
            curChoosedSupplier: {},
            historyFlag: true,
            emailInfo: '0', //发邮件选择是否隐藏项目名
            fileList: [], //上传附件列表,
            taskFIleTableData: [], //供应商文件列表
            /* 关键词搜索 */
            queryInfo: {
                tpName: '', //项目名
                tpNo: '', //项目编号
                tpState: '', //项目状态
                tsId: '', //供应商
            },
            /* 新建项目号关联到的项目 */
            relatedProjectList: [],
            showRelatedProject: false,
            //是否分析页面跳转
            hasQueryFlag: false,

        }
    },
    filters: {
        getBidsState(state) {
            console.log(state);
            let text
            switch (+state) {
                case 0:
                    text = '废标'
                    break
                case 1:
                    text = '竞标中'
                    break
                case 2:
                    text = '竞标结束'
                    break
            }
            return text
        },

    },
    watch: {
        pageSize(val) {
            this.currPage = 1
            this.hasQueryFlag ? this.findHitBidProjectList() : this.findProjectList()
        },
        queryInfo: {
            deep: true,
            handler(val) {
                console.log(val);
                let res = Object.values(val).every(t => !t.trim())
                if (res) this.hasQueryFlag ? this.findHitBidProjectList() : this.findProjectList()
            }
        }

    },
    computed: {
        title(val) {
            if (!this.editFlag) return '添加项目'
            return '修改项目'
        },
        bidsTitle(val) {
            console.log(this.bidEditFlag);
            if (!this.bidEditFlag) return '添加招标信息'
            return '修改招标信息'
        }
    },
    created() {
        let {
            tsId
        } = this.$route.query
        if (tsId) {
            this.queryInfo.tsId = tsId
            this.findHitBidProjectList()
            this.pageTitle = '中标项目信息'
            this.hasQueryFlag = true
        } else {
            this.findProjectList()
        }
        this.findSupplierList()
        this.findProjectDownList()
    },

    mounted() {
        document.querySelector('.el-main').scrollTo(0, 0)
    },
    methods: {

        /* api */
        prePage() { // 查

        },
        /* 新增项目 */
        addProject() {
            let s = deepCopy(this.a01BiddingInfoList[0].biddingSupplierList)
            this.a01BiddingInfoList[0].biddingSupplierList = s.map(t => ({
                tsId: t
            }))
            this.dialogInfo.a01BiddingInfoList = []
            this.a01BiddingInfoList[0].tbiState = '1'
            this.dialogInfo.a01BiddingInfoList.push(this.a01BiddingInfoList[0])


            api.addProject(this.dialogInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findProjectList()
                }
            })
        },
        /* 删除项目 */
        deleteProject(data) {
            api.deleteProject(data).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findProjectList()
                }
            })
        },
        /* 查询项目 */
        findProjectList() {
            api.findProjectList({
                currPage: this.currPage,
                pageSize: this.pageSize,
                ...this.queryInfo
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    let originData = d.dataList.map(t => {
                        let binding = t.a01BiddingInfoList.filter(item => {
                            if (item.tbiState == '1' || item.tbiState == '2') return item
                        })[0]
                        console.log(binding);
                        t.a01BiddingInfo = binding
                        return t
                    })
                    this.tableData = originData.map(t => {
                        return {
                            ...t,
                            ...t.a01BiddingInfo
                        }
                    })
                    console.log(this.tableData);

                    this.total = d.totalCount
                }
            })
        },

        /* 查询项目 */
        findHitBidProjectList() {
            api.findHitBidProjectList({
                currPage: this.currPage,
                pageSize: this.pageSize,
                ...this.queryInfo
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    let originData = d.dataList.map(t => {
                        let binding = t.a01BiddingInfoList.filter(item => {
                            if (item.tbiState == '1' || item.tbiState == '2') return item
                        })[0]
                        console.log(binding);
                        t.a01BiddingInfo = binding
                        return t
                    })
                    this.tableData = originData.map(t => {
                        return {
                            ...t,
                            ...t.a01BiddingInfo
                        }
                    })
                    console.log(this.tableData);

                    this.total = d.totalCount
                }
            })
        },
        /* 查询项目投标信息  */
        findProjectBidInfo(tpId) {
            api.findProjectBidInfo({ tpId }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    d.tpCustomMsg = d.tpCustomMsg ? d.tpCustomMsg.replace(/<\/br>/g, "\n") : ''
                    console.log(d);
                    this.fileList = d.fileAddBeans.map(t => {
                        let {
                            tbUrl
                        } = t
                        return {
                            name: tbUrl,
                            url: this.$baseUrl + tbUrl
                        }
                    })
                    this.editFlag = true
                    this.dialogInfo = d
                    this.dialogTableData = d.a01BiddingInfoList
                    this.curProjectInfo = d
                }
            })
        },
        /* 根据项目编号查询项目任务 */
        findProjectTaskByCode(params) {
            api.findProjectTaskByCode(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    console.log(d);
                    this.planTableData = d.map(t => {
                        t.relevance = false
                        return t
                    })
                }
            })
        },

        /* 根据项目编号查询项目名称 */
        findProjectNoByCode(params) {
            api.findProjectNoByCode(params).then(data => {
                if (data) {
                    let d = data.data.resultObject

                    this.showRelatedProject = true
                    this.relatedProjectList = d
                    this.dialogInfo.tpName = d[0]?.tpName
                    setTimeout(() => {
                        this.handleRelatedProjectSelected(d[0]?.tpName)
                    }, 100);
                    this.$message({
                        type: 'success',
                        message: '已有关联项目!'
                    })
                } else {
                    this.relatedProjectList = []
                    this.showRelatedProject = false
                    this.dialogInfo.tpName = ''
                }
            })
        },

        findProjectDownList() {                //查询项目下拉列表
            api.findProjectDownList({}).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.projectList = d
                }
            })
        },

        /* 删除投标信息 */
        deleteProjectBiddingInfo(row) {
            this.deleteProjectBiddingInfo(row).then(data => {
                if (data) {
                    this.$message.success('删除投标信息成功')
                } else {
                    this.$message.error('删除投标信息失败')
                }
            })
        },
        /* 修改项目 */
        updateProject() {
            let originData = [...this.delProjectLsit, ...this.dialogTableData]
            this.dialogInfo.a01BiddingInfoList = originData
            let d = deepCopy(this.dialogInfo.a01BiddingInfoList)
            d.map((t, i) => {
                let subList = this.dialogInfo.a01BiddingInfoList[i].supList
                if (subList) {
                    this.dialogInfo.a01BiddingInfoList[i].biddingSupplierList = subList
                }
            })
            api.updateProject(this.dialogInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.curSupplierInfo = []
                    this.findProjectList()
                }
            })
        },
        /* 修改中标状态 */
        updateBiddingState(row) {
            console.log(this.curProjectInfo);
            let open = +new Date(this.curProjectInfo.tbiOpen)
            let now = +new Date()
            if (now < open) return this.$message.info('未到开标时间,不可操作')
            this.curChoosedSupplier = deepCopy(row)
            let {
                remark
            } = this.curChoosedSupplier
            this.projectConfirmInfo = {
                price: '',
                remark
            }
            this.confrimDialogVisible = true
            this.isComplete = true

        },
        /* 修改项目采购任务时间 */
        updateProjectTaskTime(params) {
            api.updateProjectTaskTime(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.queryProjectPlanByNo()
                }
            })
        },

        /* 确认修改中标状态 */
        confirmUpdateState() {

            this.$refs.projectConfirmForm.validate(valid => {
                if (valid) {
                    this.curChoosedSupplier.tbiDocumentAmount = this.projectConfirmInfo.price
                    this.curChoosedSupplier.tbsRemark = this.projectConfirmInfo.remark
                    let {
                        tbsId,
                        tbiState,
                        tpId,
                        tbiId,
                        tbsRemark,
                        tbiDocumentAmount
                    } = this.curChoosedSupplier
                    let tbsState = '1'
                    let tpState = '0'
                    tbiState = '2'
                    api.updateBiddingState({
                        tbsRemark,
                        tbsId,
                        tbsState,
                        tpId,
                        tpState,
                        tbiState,
                        tbiId,
                        tbiDocumentAmount
                    }).then(data => {
                        if (data) {
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            });
                            this.findProjectDocument({
                                tpId
                            })
                            this.confrimDialogVisible = false

                        }
                    })
                }
            })


        },
        closeconfirmDialog() {
            this.closeconfirmDialog = {
                price: '',
                remark: '',
            }
            // this.$message({
            //     type: 'info',
            //     message: '取消操作'
            // });
        },

        /* 查询供应商列表 */
        findSupplierList() {
            api.findSupplierInfoList({}).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierList = d

                }
            })
        },
        /* 发送邮件 */
        seedEmailToSupplier(params) {
            api.seedEmailToSupplier(params).then(data => {
                if (data) {
                    this.$message.success('发送邮件成功')
                }
            })
        },
        /* 查看历史标书信息 */
        findBiddingDocument(params) {
            api.findBiddingDocument(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    let res = d.some(t => t.tbiState === '1')
                    if (res) this.isOver = false
                    this.ProjectDocumentData = d
                    this.fileDialogVisible = true
                }
            })

        },
        /* 查看项目标书信息 */
        findProjectDocument(params) {
            api.findProjectDocument(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    let res = d.filter(t => t.tbiState === '1')
                    if (res.length > 0) this.isOver = false
                    this.ProjectDocumentData = d
                    this.curProjectInfo.tbsRemark = res[0] ? res[0].tbsRemark : ''
                    this.fileDialogVisible = true
                }
            })

        },
        /* 查看供应商历史报价信息 */
        findBiddingHis(params) {
            api.findBiddingHis(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.historyPriceData = d
                    console.log(this.historyPriceData);
                    let datas = [],
                        axis = []
                    d.map(t => {
                        console.log(t);
                        let date = t.tbiDocumentDate
                        axis.push(date)
                        if (datas[t.tsId]) {
                            datas[t.tsId].push(t)
                        } else {
                            datas[t.tsId] = [t]
                        }
                    })
                    let axisSet = new Set(axis)
                    axis = Array.from(axisSet).sort((a, b) => {
                        console.log(new Date(a), new Date(b));
                        return (+new Date(a)) - (+new Date(b))
                    })
                    this.historyLineData = {
                        axis,
                        datas
                    }
                    this.historyDialogVisible = true

                    console.log(this.historyLineData);
                }
            })
        },


        /* handle */
        /* 关键词搜索 */
        queryInfoByKeyword() {
            let res = Object.values(this.queryInfo).every(t => {
                return !t.trim()
            })
            if (res) return this.$message.warning('请先输入关键词')
            this.currPage = 1

            this.hasQueryFlag ? this.findHitBidProjectList() : this.findProjectList()
        },
        submitForm() {

            this.dialogInfo.tpCustomMsg = this.dialogInfo.tpCustomMsg ? this.dialogInfo.tpCustomMsg.replace(/\n/g, '</br>') : ''
            this.dialogInfo.fileAddBeans = this.fileList.map(t => {
                return {
                    tbUrl: t.name
                }
            })
            let taskList = this.planTableData.filter(t => t.relevance)
            taskList = taskList.map(t => ({
                task_id: t.tptId
            }))
            this.dialogInfo.taskList = taskList ? taskList : []
            if (!this.editFlag) {
                let bids = this.a01BiddingInfoList[0]
                let start = +new Date(bids.tbiStart.replace(/-/g, '/'))
                let end = +new Date(bids.tbiEnd.replace(/-/g, '/'))
                let open = +new Date(bids.tbiOpen.replace(/-/g, '/'))
                if (!this.dialogInfo.tpName || !this.dialogInfo.tpNo) return this.$message.warning('带星号为必须填写')
                let now = +new Date()
                if (end < now || open < now) return this.$message.warning('结束时间和开标时间需要大于当前时间')
                if (end < start) return this.$message.warning('结束时间必须大于开始时间')
                if (open < end) return this.$message.warning('开标时间必须大于结束时间')
                if (!start || !end || !open) return this.$message.warning('项目时间必须选择')
                if (!bids.biddingSupplierList.length) return this.$message.warning('供应商必须选择')
                this.addProject()
            } else {
                this.updateProject()
            }
            // this.updateProjectTaskTime(projectTaskData)
            this.dialogVisible = false
        },
        /* 上传招标信息修改 */
        submitBidsEdit() {
            let bids = this.a01BiddingInfoList[0] //时间验证
            let start = +new Date(bids.tbiStart.replace(/-/g, '/'))
            let end = +new Date(bids.tbiEnd.replace(/-/g, '/'))
            let open = +new Date(bids.tbiOpen.replace(/-/g, '/'))
            if (!start || !end || !open) return this.$message.warning('时间必须选择')
            if (end < start) return this.$message.warning('结束时间必须大于开始时间')
            if (open < end) return this.$message.warning('开标时间必须大于结束时间')

            this.a01BiddingInfoList[0].tbiState = '1'
            let supList = []
            let newSupList = []
            let data = deepCopy(this.a01BiddingInfoList[0].biddingSupplierList)
            this.curSupplierInfo.map(t => {
                if (data.includes(t.tsId)) {
                    supList.push(t)
                    let i = data.indexOf(t.tsId)
                    data.splice(i, 1)
                } else {
                    t.isDel = '1'
                    supList.push(t)
                }

            })
            newSupList = data.length ? data.map(item => ({
                tsId: item
            })) : []
            this.a01BiddingInfoList[0].supList = [...supList, ...newSupList]
            if (!this.bidEditFlag) {
                this.dialogTableData.map(t => {
                    t.tbiState = '0'
                })
                this.dialogTableData.push(this.a01BiddingInfoList[0])
                console.log(this.dialogTableData);
            } else {
                let i = this.curBidsIndex
                let d = this.a01BiddingInfoList[0]
                this.dialogTableData.splice(i, 1, d)
            }
            let p = this.curProjectInfo //当前选择的项目信息



            if (p.fileAddBeans && p.fileAddBeans.length) {
                this.fileList = p.fileAddBeans.map(t => { //附件
                    let {
                        tbUrl
                    } = t
                    return {
                        name: tbUrl,
                        url: tbUrl
                    }
                })
            }

            p.tpCustomMsg = p.tpCustomMsg ? p.tpCustomMsg.replace(/<\/br>/g, "\n") : ''

            this.editFlag = true
            this.dialogVisible = true
            this.bidEditFlag = false
            this.bidsDialogVisible = false
            this.a01BiddingInfoList = [{}]

        },

        openDetailDialog() {
            this.findSupplierList()

        },
        closeDetailDialog() {
            this.dialogInfo = {}
            this.editFlag = false
            this.a01BiddingInfoList = [{}]
            this.delProjectLsit = []
            this.fileList = []
            this.planTableData = []

            this.relatedProjectList = []
            this.showRelatedProject = false
        },
        closeFileInfoDialog() {
            this.ProjectDocumentData = []
            this.hasQueryFlag ? this.findHitBidProjectList() : this.findProjectList()
            this.isOver = true
        },

        closeBidsDialog() {
            this.bidEditFlag = false
            this.a01BiddingInfoList = [{}]
            this.bidsDialogVisible = false
        },
        /* 添加新招标信息 */
        addNewBids() {
            let d = this.curProjectInfo
            console.log(d);
            this.bidEditFlag = false
            this.bidsDialogVisible = true
            this.fileDialogVisible = false
            this.dialogInfo = d
            this.dialogTableData = d.a01BiddingInfoList
            let biggest = 0
            this.dialogTableData.map(t => {
                biggest = t.tbiId > biggest ? t.tbiId : biggest
            })
            let newest = this.dialogTableData.find(t => t.tbiId == biggest)
            this.a01BiddingInfoList[0].biddingSupplierList = newest.biddingSupplierList.map(key => key.tsId)
        },
        /* 项目信息修改 */
        openModify(row) {
            let { tpId } = row
            this.findProjectBidInfo(tpId)
            this.dialogVisible = true
        },
        /* 打开投标信息修改 */
        openBidsModify(i, row) {
            this.bidEditFlag = true
            this.curBidsIndex = i
            let d = deepCopy(row)
            if (d.biddingSupplierList && typeof d.biddingSupplierList[0] == 'object') {
                this.curSupplierInfo = deepCopy(d.biddingSupplierList)
                d.biddingSupplierList = d.biddingSupplierList.map(key => key.tsId)
            }
            this.a01BiddingInfoList = [d]
            this.bidsDialogVisible = true
        },
        /* 查看项目信息 投标文件  */
        openBidsDetail(row) {

            let d = deepCopy(row)
            console.log(row);
            this.curProjectInfo = d
            let {
                tpId,
                tbiOpen,
                tpNo,
                tbiState,
                isGreater
            } = d
            this.findProjectDocument({
                tpId,
                isGreater
            })
            let open = +new Date(tbiOpen)
            let now = +new Date()
            this.isOpen = open < now
            this.isComplete = tbiState == '2' ? true : false
            this.findProjectBidInfo(tpId)
        },

        /* 查看历史标书信息 */
        openHistoryBids(row) {
            let {
                tbiId,
                tbiState,
                tbiOpen
            } = row
            this.isOver = tbiState == '0' ? true : false
            this.findBiddingDocument({
                tbiId
            })
        },

        /* 查看项目历史报价 */
        showHistoryPrice() {
            let tpId = this.curProjectInfo.tpId
            console.log(this.curProjectInfo);
            this.findBiddingHis({
                tpId
            })
        },
        closeHistoryDialog() {
            this.historyPriceData = []
            this.historyLineData = []
        },
        /* 项目任务 */
        /* 根据项目编号查询项目任务 */
        queryProjectPlanByNo(val) {
            let {
                tpNo
            } = this.dialogInfo
            if (!tpNo || this.editFlag) return
            this.findProjectTaskByCode({
                tpNo
            })
        },
        //处理关联项目选择
        handleRelatedProjectSelected(val) {
            let item = this.relatedProjectList.find(t => t.tpName == val)
            console.log(item);
            this.dialogInfo.tpNo = item.tpNo
        },
        queryProjectByNo(val) {
            let {
                tpNo
            } = this.dialogInfo
            console.log(this.editFlag);
            if (!tpNo || this.editFlag) return
            this.findProjectNoByCode({
                tpNo
            })
        },

        /* 修改项目实际开始时间 */
        modifyPlanOpen(i) {
            this.planTableData[i].relevance = !this.planTableData[i].relevance
        },
        openDownLoadDialog(row) {
            console.log(row);
            let {
                biddingSupplierDocBeanList,
                tbiDocumentPath
            } = row
            if (biddingSupplierDocBeanList && biddingSupplierDocBeanList.length > 0) {
                this.taskFIleTableData = biddingSupplierDocBeanList
            } else if (tbiDocumentPath) {
                this.taskFIleTableData = [{
                    tbiDocumentPath
                }]
            } else {
                this.taskFIleTableData = []
            }
            console.log(this.taskFIleTableData);
            this.downloadFileVisible = true
        },
        /* 下载文件 */
        downLoadFile(row) {
            console.log(row);
            let openTime = +new Date(this.curProjectInfo.tbiOpen)
            let res = +new Date() < openTime
            let {
                tbiDocumentPath: url
            } = row
            // 处理url中的#号
            if(url.includes('#')) url = url.replace('#','%23')
                
            if (res) return this.$message.info('未到开标时间,不能下载该文件')
            let type = url.split('.').pop()
            let imgArr = ['png', 'jpg', 'jpeg', 'gif']
            if (imgArr.includes(type)) {
                const image = new Image();
                image.src = this.$baseUrl + url;
                // 解决跨域 Canvas 污染问题
                image.setAttribute('crossOrigin', 'anonymous');
                // eslint-disable-next-line func-names
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
                    const imgUrl = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
                    const a = document.createElement('a'); // 生成一个a元素
                    a.download = url; // 设置图片名称
                    a.href = imgUrl; // 将生成的URL设置为a.href属性
                    a.click();
                };
            }
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = this.$baseUrl + url
            // link.target = '_blank'
            link.download = url
            link.click()
        },
        /* 当前行是否高亮 */
        isHighLight({
            row
        }) {
            let {
                tbiState
            } = row
            console.log(tbiState);
            if (tbiState === '1') return 'heightLight'
        },
        deleteThis(row) {
            this.deleteProject(row)
        },
        deleteBidsInfo(i) {
            let d = this.dialogTableData.splice(i, 1)[0]
            d.isDel = '1'
            this.delProjectLsit.push(d)
        },
        handleCurPageChange(val) {
            this.currPage = val
            this.hasQueryFlag ? this.findHitBidProjectList() : this.findProjectList()
        },
        /* 发送邮件 */
        seedEmail(row) {
            this.seedEmailToSupplier({
                tbsIdList: [],
                tpId: row.tpId,
                isShowName: this.emailInfo,
            })

        },
        /* hanle upload */
        handlePreview(file) { },
        // handleExceed(files, fileList) {
        //   this.$message.warning(`当前只能上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        // },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        /* 上传附件 */
        uploadFile(params) {
            const formdata = new FormData()
            const file = params.file
            let type = '.' + file.name.split('.').pop()
            if (type === '.txt') {
                this.$message.warning('不支持txt文件')
                this.fileList = []
                return
            }
            // let newFile = new File([file], file.name.replace(type, '-' + timeFilter(new Date()) + type))
            // console.log(newFile);
            formdata.append('file', file)
            api.filesUpload(formdata)
                .then(data => {
                    if (data.data.resultObject == 200) {
                        this.$message({
                            message: '新增成功',
                            type: 'success',
                        });
                    }
                    const file = data.data.resultObject
                    console.log(file);
                    let urlInfo = {
                        name: file,
                        url: file
                    }
                    this.fileList.push(urlInfo)
                }).catch((err) => { })
        },
        /* 移除附件 */
        handleRemove(file, fileList) {
            console.log(fileList);
            this.fileList = fileList
        },


        // 索引
        indexMethod(index) {
            return (this.currPage - 1) * this.pageSize + index + 1
        },
        /* 手机端无法搜索 */
        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const selects = Array.from(document.querySelectorAll('.mySelect'))
                    selects.map(t => {
                        let input = t.querySelector('.el-input__inner')
                        input.removeAttribute('readonly');
                    })
                }
            });
        },


    },
}